<template>
    <div class="view-wrap">
        <div class="view-hd" @click="$parent.visible = true">
            <span>{{ $parent.statusFilter(detail.orderStatus) }}</span>
            <van-icon name="arrow" />
        </div>
        <div class="view-bd" v-if="detail.orderStatus === 1">
            <p class="view-bd-title">请尽快付款</p>
            <p class="view-bd-subTitle">超过15分钟未支付，订单将自动取消</p>
        </div>
        <div class="view-ft">
            <van-button
                size="small"
                color="#EB5435"
                v-if="detail.orderStatus==1"
                @click="confirmPay"
                >立即付款</van-button>
            <van-button
                size="small"
                color="#434343"
                v-if="detail.orderStatus==1"
                hairline plain
                @click="cancelOrderFn(detail.orderId)">取消订单</van-button>
            <van-button
                size="small"
                v-if="detail.orderStatus==15 && detail.businessProperty==2"
                @click="$router.push('/deliveryDetails?orderNumber='+detail.orderId)">查看物流</van-button>
            <van-button
                size="small"
                v-if="detail.orderStatus==9"
                @click="deleteOrderFn(detail.orderId)">删除订单</van-button>
            <van-button
                size="small"
                type="danger"
                v-if="detail.businessProperty == 2 ? detail.orderStatus == 15 : detail.orderStatus == 4"
                @click="confirmOrderFn(detail.orderId)">确认收货</van-button>
            <van-button
                size="small"
                type="primary"
                v-if="detail.orderStatus==5"
                @click="$router.push('/comment?orderNumber='+detail.orderId)">评价</van-button>
            <a :href="`tel:${detail.businessPhone}`">
                <van-button
                    size="small"
                    color="#434343"
                    hairline plain>售后联系</van-button>
            </a>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
    props: {
        detail: Object
    },
    methods: {
        ...mapActions('myOrder', {
            cancelOrder: 'cancelOrderAction',
            deleteOrder: 'deleteOrderAction',
            confirmOrder: 'confirmOrderAction'
        }),
        confirmPay() {
            this.$commonPay({
                data: {
                    xmBh:this.detail.businessDetailsVo.businessNumber+','+this.detail.businessDetailsVo.businessCompanyBonus+','+this.detail.businessDetailsVo.businessPlatformBonus+','+this.detail.businessDetailsVo.businessProperties+','+this.detail.deliverMethods+','+this.detail.businessDetailsVo.payRate+','+this.detail.sendMoney,
                    tradeNo:this.detail.orderId,
                    totalFee:this.detail.orderFactMoney,
                    orderDesc:'欣商城',
                    gsbh:this.detail.businessCompanyId
                },
                successFn: () => {
                    this.$router.back();
                }
            });
        },
        cancelOrderFn(id) {
            this.$dialog.confirm({
                title: '提示',
                message: '您确定要取消该订单吗？'
            }).then(() => {
                this.cancelOrder(id).then((res) => {
                    this.$parent.getOrderDetail(this.$route.params.id);
                    this.$toast(res.msg);
                }).catch((res) => {
                    this.$toast(res.error);
                });
            });
        },
        deleteOrderFn(id) {
            this.$dialog.confirm({
                title: '提示',
                message: '您确定要删除该订单吗？'
            }).then(() => {
                this.deleteOrder({ orderNumber: id }).then((res) => {
                    this.$toast(res.msg);
                    this.$router.back();
                }).catch((res) => {
                    this.$toast(res.error);
                });
            });
        },
        confirmOrderFn(id) {
            this.$dialog.confirm({
                title: '提示',
                message: '您确定要收货吗？'
            }).then(() => {
                this.confirmOrder(id).then((res) => {
                    this.$parent.getOrderDetail(this.$route.params.id);
                    this.$toast(res.msg);
                }).catch((res) => {
                    this.$toast(res.error);
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.view-wrap {
    margin: 12px;
    padding: 0 17px;
    border-radius: 5px;
    background-color: #FFFFFF;

    .view-hd {
        font-size: 25px;
        color: #333333;
        padding: 15px 0;
        border-bottom: 1px solid #E5E5E5;

        i {
            vertical-align: middle;
        }
    }
    .view-bd {
        padding-top: 17px;

        .view-bd-title {
            color: #333333;
            font-size: 15px;
            margin-bottom: 12px;
        }
        .view-bd-subTitle {
            color: #8A8A8A;
            font-size: 12px;
        }
    }
    .view-ft {
        padding-top: 17px;
        padding-bottom: 24px;

        button {
            margin-right: 15px;
        }
    }
}
</style>